import { helper } from '@ember/component/helper';

/**
 * Converte un valore in numero gestendo stringhe con virgola
 */
const toNumber = val => {
  if (typeof val === 'number') return val;
  if (typeof val === 'string') {
    const normalized = val.trim();
    // Number('') e Number('   ') danno 0: sarebbe un divisore zero fittizio.
    return normalized === '' ? NaN : Number(normalized.replace(',', '.'));
  }
  return NaN;
};

/**
 * Calcola la divisione tra numeri (protetto da divisione per zero)
 */
var numberDiv = helper(function numberDiv(numbers) {
  if (!Array.isArray(numbers) || numbers.length === 0) return 0;
  const validNumbers = numbers.map(toNumber).filter(n => !isNaN(n));
  if (validNumbers.length < 2) return validNumbers[0] ?? 0;

  // Divisione per zero restituisce 0 anziché propagare il dividendo
  return validNumbers.reduce((acc, val) => val === 0 ? 0 : acc / val);
});

export { numberDiv as default };
//# sourceMappingURL=number-div.js.map
